/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const CalendarRegularV6 = (props) => (
  <Icon {...props} name="Calendar Regular V6">
    <path d="M5.75 2h4.5V.75a.749.749 0 1 1 1.5 0V2H13a2 2 0 0 1 2 2v10c0 1.103-.897 2-2 2H3a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h1.25V.75a.749.749 0 1 1 1.5 0V2zM2.5 14a.5.5 0 0 0 .5.5h10c.275 0 .5-.225.5-.5V6h-11v8z" />
  </Icon>
);

export default CalendarRegularV6;
